export const determineReturnURL = () => {
	if (
		!window.location.pathname.includes('login') &&
		!window.location.pathname.includes('logout')
	) {
		return `${window.location.pathname}${window.location.search}${window.location.hash}`;
	}
};
